/**
 * Confere uma rolagem antes de mandá-la ao servidor, com a mensagem na língua de quem rolou
 * (o parser compartilhado só fala português). Devolve null quando a rolagem vale.
 */
import { LIMITS, RolagemError, parseRolagem } from '../shared.js';

type Translate = (key: string, params?: Record<string, string | number>) => string;

export function rollProblem(expression: string, t: Translate): string | null {
  // o servidor recusa a mensagem inteira acima disso, com o texto cru do validador
  if (expression.length > LIMITS.diceExpression) return t('dice.error.tooLong', { max: LIMITS.diceExpression });
  try {
    parseRolagem(expression);
    return null;
  } catch (error) {
    return error instanceof RolagemError ? t(`dice.error.${error.code}`, { detail: error.detail }) : error instanceof Error ? error.message : String(error);
  }
}
